import { createContext, useContext, useEffect } from "react";

/*
 * IEFTINIT.RO Control Hub — LIGHT MODE ONLY.
 *
 * The dark theme has been retired. We keep a noop `useTheme()` export so existing
 * call sites (DashboardLayout, public form pages, sonner) compile without changes
 * and can be cleaned up incrementally. `toggle` and `setTheme` are intentionally
 * inert.
 */
const ThemeContext = createContext({ theme: "light", toggle: () => {}, setTheme: () => {} });

export function ThemeProvider({ children }) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark");
    // Clean any stale persisted preference from the previous dark-mode era.
    try { localStorage.removeItem("theme"); } catch {}
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: "light", toggle: () => {}, setTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
